import im from "../models/im";

export const types = {
  IM_DATA: "IM_DATA",
  IM_DATA_SUCCESS: "IM_DATA_SUCCESS",
  IM_DATA_FAILED: "IM_DATA_FAILED",
  IM_SUBMIT: "IM_SUBMIT",
  IM_SUBMIT_SUCCESS: "IM_SUBMIT_SUCCESS",
  IM_SUBMIT_FAILED: "IM_SUBMIT_FAILED",
};

export const actions = {
  imDataGet: (payload) => {
    return { type: types.IM_DATA, value: payload };
  },
  imSubmit: (payload, callback = () => { }) => {
    return { type: types.IM_SUBMIT, value: payload, callback };
  },
};

const reducer = (state = im, action) => {
  switch (action.type) {
    case types.IM_DATA_SUCCESS:
      const { data = {} } = state;
      return {
        ...state,
        loading: false,
        retrived: true,
        data: {
          ...data,
          ...action.value,
        },
        viewConfig: {
          title: {
            en: 'Internal Management',
            fr: 'Gestion Interne',
          }
        },
      }
    case types.IM_DATA_FAILED:
      return {
        ...state,
        loading: false,
        errors: action.value || null,
      };
    case types.IM_SUBMIT:
      return {
        ...state,
        loading: true,
      };
    case types.IM_SUBMIT_SUCCESS:
      const { module, view, ...formData } = action.value;
      state.data[`${module}-${view}`]
        ? state.data[`${module}-${view}`].data = formData
        : state.data[`${module}-${view}`] = { ...formData };
      return {
        ...state,
        data: {
          ...state.data,
        },
        loading: false,
      };
    default:
      return state;
  }
}

export default reducer;
